// @flow
import React from 'react';
import { imageURL, numberWithCommas } from 'lib/common';
import Button from 'components/common/Button';
import { isBrowser } from 'react-device-detect';
import './WishTemplate.scss';

type Props = {
  wish: any,
  items: any,
  goProduct: any,
  allCheckedWish: any,
  updateCheckedWish: any,
  emptyWish: any,
  updateItemWish: any,
  deleteItemCheckedWish: any,
  deleteItemWish: any,
  onOffer: any,
  onShopping: any,
  onOrder: any,
  gradeDiscount: any,
};

const WishTemplate = (props: Props) => (
  <div className="WishTemplate">
    <div className="wish">
      <div className="wish-items">
        <div className="wish-header">
          <div className="wish-title-section">
            <h2>
              <button
                className="back-button"
                onClick={() => window.history.back()}
                aria-label="뒤로가기"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M19 12H5M12 19l-7-7 7-7" />
                </svg>
              </button>
              찜 목록
            </h2>
            <span className="item-count">{props.wish.items.length}개 상품</span>
          </div>
          <div className="wish-actions desktop-only">
            <button
              className="delete-selected-btn"
              onClick={props.removeSelectedWish}
              disabled={!props.wish.items.some(item => item.checked)}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M3 6h18M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6m3 0V4c0-1 1-2 2-2h4c0 1 1 2 2 2v2" />
                <line x1="10" y1="11" x2="10" y2="17" />
                <line x1="14" y1="11" x2="14" y2="17" />
              </svg>
              선택삭제
            </button>
          </div>
        </div>

        {/* 전체선택 컨트롤 */}
        <div className="select-all-section mobile-only">
          <label className="select-all-checkbox" htmlFor="select-all-wish">
            <input
              id="select-all-wish"
              name="allChecked"
              type="checkbox"
              checked={props.wish.allChecked}
              onChange={props.allCheckedWish}
            />
            <span className="checkmark"></span>
            <span className="select-all-text">
              {props.wish.items.filter(item => item.checked).length > 0
                ? `${props.wish.items.filter(item => item.checked).length}개선택`
                : '전체선택'}
            </span>
          </label>
          <div className="wish-actions">
            <button
              className="delete-selected-btn"
              onClick={props.removeSelectedWish}
              disabled={!props.wish.items.some(item => item.checked)}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M3 6h18M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6m3 0V4c0-1 1-2 2-2h4c0 1 1 2 2 2v2" />
                <line x1="10" y1="11" x2="10" y2="17" />
                <line x1="14" y1="11" x2="14" y2="17" />
              </svg>
              선택삭제
            </button>
          </div>
        </div>

        {/* 데스크톱 테이블 */}
        <div className="wish-table-wrapper desktop-only">
          <table className="cart-table">
            <thead>
              <tr>
                <th className="col-checkbox">
                  <label className="header-select-all-checkbox" htmlFor="header-select-all-wish">
                    <input
                      id="header-select-all-wish"
                      name="allChecked"
                      type="checkbox"
                      checked={props.wish.allChecked}
                      onChange={props.allCheckedWish}
                    />
                    <span className="checkmark"></span>
                  </label>
                </th>
                <th className="col-image">이미지</th>
                <th className="col-product">상품정보</th>
                <th className="col-unit-price">단가</th>
                <th className="col-quantity">수량</th>
                <th className="col-price">가격</th>
                <th className="col-actions">삭제</th>
              </tr>
            </thead>
            <tbody>
              {props.wish.items.length === 0 ? (
                <tr className="wish-has-no-items">
                  <td colSpan="7">
                    <p>찜 목록에 상품이 하나도 없습니다.</p>
                  </td>
                </tr>
              ) : (
                props.wish.items.map((item, index) => (
                  <tr key={item.id} className="wish-item">
                    <td className="wish-item-checkbox">
                      <label className="item-checkbox" htmlFor={`wish-item-checkbox-${index}`}>
                        <input
                          id={`wish-item-checkbox-${index}`}
                          name="isGoing"
                          type="checkbox"
                          checked={item.checked}
                          onChange={() => props.updateCheckedWish(index)}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                    <td className="wish-item-thumbnail-container">
                      <div className="product-image">
                        <a
                          onClick={() => props.goProduct(item.product.id)}
                          className="wish-item-name-link"
                        >
                          <img
                            src={item.product ? imageURL(item.product.thumbnail, 120, 120) : ''}
                            className="wish-item-thumbnail"
                            alt="thumbnail"
                          />
                        </a>
                      </div>
                    </td>
                    <td className="wish-item-name">
                      <div className="wish-item-summary">
                        <h3 className="product-name">
                          {item.product ? (
                            <a
                              onClick={() => props.goProduct(item.product.id)}
                              className="wish-item-name-link"
                            >
                              {item.product.name}
                            </a>
                          ) : (
                            <span className="deleted-product">삭제된 상품</span>
                          )}
                        </h3>
                        <div className="product-details">
                          {item.product_price && (
                            <div className="detail-item">
                              <span className="detail-label">카탈로그 번호:</span>
                              <span className="detail-value">{item.product_price.part_number}</span>
                            </div>
                          )}
                          {item.product_price && (
                            <div className="detail-item">
                              <span className="detail-label">설명:</span>
                              <span className="detail-value">{item.product_price.description}</span>
                            </div>
                          )}
                          {item.product_price && (
                            <div className="detail-item">
                              <span className="detail-label">단위:</span>
                              <span className="detail-value">{item.product_price.unit}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                    {item.price ? (
                      <td className="wish-item-price">
                        {item.price.sale.raw !== item.price.original.raw && (
                          <span className="wish-item-compare-price">
                            {numberWithCommas(item.price.original.raw)}원
                          </span>
                        )}
                        <span className="wish-item-sale-price">
                          {numberWithCommas(item.price.sale.raw)}원
                        </span>
                      </td>
                    ) : (
                      <td className="wish-item-price">
                        <span className="wish-item-sale-price">
                          {numberWithCommas(item.product_price.price)}원
                        </span>
                      </td>
                    )}
                    <td className="wish-item-quantity">
                      <div className="quantity-control">
                        <button
                          type="button"
                          className="quantity-btn minus"
                          onClick={() => {
                            if (item.quantity > 1) {
                              const event = { target: { value: item.quantity - 1 } };
                              props.updateItemWish(index, item.id, event);
                            }
                          }}
                          disabled={item.quantity <= 1}
                        >
                          <svg width="12" height="2" viewBox="0 0 12 2" fill="none">
                            <path d="M0 1H12" stroke="currentColor" strokeWidth="2" />
                          </svg>
                        </button>
                        <input
                          name="itemQuantity"
                          min="1"
                          onChange={event => props.updateItemWish(index, item.id, event)}
                          value={item.quantity}
                          className="quantity-input"
                          required
                          type="text"
                          pattern="[1-9]*"
                        />
                        <button
                          type="button"
                          className="quantity-btn plus"
                          onClick={() => {
                            const event = { target: { value: item.quantity + 1 } };
                            props.updateItemWish(index, item.id, event);
                          }}
                        >
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M6 0V12M0 6H12" stroke="currentColor" strokeWidth="2" />
                          </svg>
                        </button>
                      </div>
                    </td>
                    {item.price ? (
                      <td className="wish-item-price">
                        {item.price.sale.raw !== item.price.original.raw && (
                          <span className="wish-item-compare-price">
                            {numberWithCommas(item.quantity * item.price.original.raw)}원
                          </span>
                        )}
                        <span className="wish-item-sale-price">
                          {numberWithCommas(item.quantity * item.price.sale.raw)}원
                        </span>
                      </td>
                    ) : (
                      <td className="wish-item-price">
                        <span className="wish-item-sale-price">
                          {numberWithCommas(item.quantity * item.product_price.price)}원
                        </span>
                      </td>
                    )}
                    <td className="action-delete-wish-item">
                      <button
                        className="delete-wish-item"
                        onClick={() => props.deleteItemWish(index, item.id)}
                        type="button"
                      >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path
                            d="M12 4L4 12M4 4L12 12"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            {!!props.wish.items.length && (
              <tfoot className="wish-footer">
                <tr className="wish-total">
                  <td colSpan="5" className="total-label">
                    <span>선택상품 합계</span>
                  </td>
                  <td colSpan="2" className="total-value">
                    <span className="total-amount">
                      {numberWithCommas(
                        props.wish.items
                          .filter(item => item.checked)
                          .reduce((accumulator, currentItem) => {
                            return (
                              accumulator + currentItem.quantity * currentItem.product_price.price
                            );
                          }, 0),
                      )}
                      원
                    </span>
                  </td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>

        {/* 모바일 카드 레이아웃 */}
        <div className="wish-mobile-container mobile-only">
          {props.wish.items.length === 0 ? (
            <div className="empty-wish-mobile">
              <p>천 목록에 상품이 하나도 없습니다.</p>
            </div>
          ) : (
            props.wish.items.map((item, index) => (
              <div key={item.id} className="wish-item-card">
                <div className="wish-item-header">
                  <label className="item-checkbox" htmlFor={`mobile-wish-item-checkbox-${index}`}>
                    <input
                      id={`mobile-wish-item-checkbox-${index}`}
                      name="isGoing"
                      type="checkbox"
                      checked={item.checked}
                      onChange={() => props.updateCheckedWish(index)}
                    />
                    <span className="checkmark"></span>
                  </label>

                  <div className="product-info-compact">
                    <div className="product-name-line">
                      {item.product ? (
                        <a
                          onClick={() => props.goProduct(item.product.id)}
                          className="wish-item-name-link product-name-compact"
                        >
                          {item.product.name}
                        </a>
                      ) : (
                        <span className="deleted-product product-name-compact">삭제된 상품</span>
                      )}
                    </div>
                    <div className="product-details-line">
                      {item.product_price && (
                        <React.Fragment>
                          <span className="catalog-number">{item.product_price.part_number}</span>
                          <span className="unit-info">{item.product_price.unit}</span>
                        </React.Fragment>
                      )}
                    </div>
                  </div>

                  <button
                    className="delete-wish-item-mobile"
                    onClick={() => props.deleteItemWish(index, item.id)}
                    type="button"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path
                        d="M12 4L4 12M4 4L12 12"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </button>
                </div>

                <div className="wish-item-content">
                  <div className="product-image-mobile">
                    <a
                      onClick={() => props.goProduct(item.product.id)}
                      className="wish-item-name-link"
                    >
                      <img
                        src={item.product ? imageURL(item.product.thumbnail, 120, 120) : ''}
                        className="wish-item-thumbnail-mobile"
                        alt="thumbnail"
                      />
                    </a>
                  </div>

                  <div className="product-info-mobile">
                    <div className="product-details-mobile">
                      {item.product_price && (
                        <div className="detail-item-mobile">
                          <span className="detail-value">{item.product_price.description}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="wish-item-pricing-mobile">
                  <div className="price-section-mobile">
                    {/* <div className="unit-price-mobile">
                      <span className="price-label">단가</span>
                      {item.price ? (
                        <div className="price-value">
                          <span className="sale-price">{numberWithCommas(item.price.sale.raw)}원</span>
                          {item.price.sale.raw !== item.price.original.raw && (
                            <span className="compare-price">
                              {numberWithCommas(item.price.original.raw)}원
                            </span>
                          )}
                        </div>
                      ) : (
                        <span className="sale-price">
                          {numberWithCommas(item.product_price.price)}원
                        </span>
                      )}
                    </div> */}

                    <div className="quantity-section-mobile">
                      <span className="quantity-label">수량</span>
                      <div className="quantity-control-mobile">
                        <button
                          type="button"
                          className="quantity-btn minus"
                          onClick={() => {
                            if (item.quantity > 1) {
                              const event = { target: { value: item.quantity - 1 } };
                              props.updateItemWish(index, item.id, event);
                            }
                          }}
                          disabled={item.quantity <= 1}
                        >
                          <svg width="12" height="2" viewBox="0 0 12 2" fill="none">
                            <path d="M0 1H12" stroke="currentColor" strokeWidth="2" />
                          </svg>
                        </button>
                        <input
                          name="itemQuantity"
                          min="1"
                          onChange={event => props.updateItemWish(index, item.id, event)}
                          value={item.quantity}
                          className="quantity-input-mobile"
                          required
                          type="text"
                          pattern="[1-9]*"
                        />
                        <button
                          type="button"
                          className="quantity-btn plus"
                          onClick={() => {
                            const event = { target: { value: item.quantity + 1 } };
                            props.updateItemWish(index, item.id, event);
                          }}
                        >
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M6 0V12M0 6H12" stroke="currentColor" strokeWidth="2" />
                          </svg>
                        </button>
                      </div>
                    </div>

                    <div className="total-price-mobile">
                      <span className="total-label">가격</span>
                      <div className="total-value">
                        {item.product_price.price !== item.product_price.original_price && (
                          <span className="total-compare-price">
                            {numberWithCommas(item.quantity * item.product_price.original_price)}원
                          </span>
                        )}
                        <span className="total-amount">
                          {numberWithCommas(item.quantity * item.product_price.price)}원
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}

          {/* 모바일 합계 */}
          {!!props.wish.items.length && (
            <div className="wish-actions-mobile">
              <div className="wish-total-mobile">
                <span className="total-label-mobile">선택상품 합계</span>
                <span className="total-amount-mobile">
                  {numberWithCommas(
                    props.wish.items
                      .filter(item => item.checked)
                      .reduce((accumulator, currentItem) => {
                        return accumulator + currentItem.quantity * currentItem.product_price.price;
                      }, 0),
                  )}
                  원
                </span>
              </div>
            </div>
          )}
        </div>

        <div className="checkout-section">
          <div className="checkout-actions">
            <div className="checkout-left-buttons">{/* 빈 공간 */}</div>
            <div className="checkout-right-buttons">
              {/* <Button color="gray" theme="outline" className="checkout-continue-btn" onClick={props.onShopping} >
                쇼핑 계속하기
              </Button> */}
              <Button className="checkout-order-btn" onClick={props.onOrder}>
                장바구니 담기
              </Button>
            </div>
          </div>
        </div>

        {/* 모바일 전용 고정 하단 장바구니 담기 버튼 */}
        <div className="mobile-fixed-checkout mobile-only">
          <div className="mobile-checkout-content">
            <div className="mobile-total-info">
              <span className="mobile-total-label">총 금액</span>
              <span className="mobile-total-price">
                {numberWithCommas(
                  props.wish.items
                    .filter(item => item.checked)
                    .reduce((accumulator, currentItem) => {
                      return accumulator + currentItem.quantity * currentItem.product_price.price;
                    }, 0),
                )}
                원
              </span>
            </div>
            <Button className="mobile-order-btn" onClick={props.onOrder}>
              장바구니 담기
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default WishTemplate;



// WEBPACK FOOTER //
// ./src/components/wish/WishTemplate/WishTemplate.js